import { gql } from '@apollo/client';

export const TIME_CLOCK_ENTRY_FIELDS = gql`
  fragment TimeClockEntryFields on TimeClockEntry {
    id
    userId
    clockedInAt
    clockedOutAt
    durationMinutes
    status
    clockInSource
    clockOutSource
    clockInLatitude
    clockInLongitude
    clockInAccuracyMeters
    clockOutLatitude
    clockOutLongitude
    clockOutAccuracyMeters
    clockInOfficeName
    clockOutOfficeName
    clockInDistanceMeters
    clockOutDistanceMeters
    clockInOutsideRadius
    clockOutOutsideRadius
    clockInOffline
    clockOutOffline
    offlineSyncedAt
    isEdited
    editedAt
    notes
    updatedAt
    user {
      id
      firstName
      lastName
      email
      role
      areas
      isContractor
      timeClockHourlyRate
    }
  }
`;

export const MY_TIME_CLOCK_SUMMARY = gql`
  ${TIME_CLOCK_ENTRY_FIELDS}
  query MyTimeClockSummary($startDate: String, $endDate: String) {
    myTimeClockSummary(startDate: $startDate, endDate: $endDate) {
      totalMinutes
      totalHours
      totalCost
      activeEntry {
        ...TimeClockEntryFields
      }
      entries {
        ...TimeClockEntryFields
      }
    }
  }
`;

export const TIME_CLOCK_ENTRIES = gql`
  ${TIME_CLOCK_ENTRY_FIELDS}
  query TimeClockEntries($input: TimeClockEntriesQueryInput) {
    timeClockEntries(input: $input) {
      ...TimeClockEntryFields
    }
  }
`;

export const CURRENTLY_CLOCKED_IN = gql`
  ${TIME_CLOCK_ENTRY_FIELDS}
  query CurrentlyClockedIn {
    currentlyClockedIn {
      ...TimeClockEntryFields
    }
  }
`;

export const TIME_CLOCK_USER_SUMMARIES = gql`
  query TimeClockUserSummaries($startDate: String, $endDate: String) {
    timeClockUserSummaries(startDate: $startDate, endDate: $endDate) {
      userId
      userName
      role
      areas
      totalMinutes
      totalHours
      hourlyRate
      totalCost
      flaggedEntriesCount
      isCurrentlyClockedIn
    }
  }
`;

export const CLOCK_IN = gql`
  ${TIME_CLOCK_ENTRY_FIELDS}
  mutation ClockIn($input: TimeClockPunchInput!) {
    clockIn(input: $input) {
      ...TimeClockEntryFields
    }
  }
`;

export const CLOCK_OUT = gql`
  ${TIME_CLOCK_ENTRY_FIELDS}
  mutation ClockOut($input: TimeClockPunchInput!) {
    clockOut(input: $input) {
      ...TimeClockEntryFields
    }
  }
`;

export const ADMIN_CREATE_TIME_CLOCK_ENTRY = gql`
  ${TIME_CLOCK_ENTRY_FIELDS}
  mutation AdminCreateTimeClockEntry($input: AdminCreateTimeClockEntryInput!) {
    adminCreateTimeClockEntry(input: $input) {
      ...TimeClockEntryFields
    }
  }
`;

export const ADMIN_UPDATE_TIME_CLOCK_ENTRY = gql`
  ${TIME_CLOCK_ENTRY_FIELDS}
  mutation AdminUpdateTimeClockEntry($input: AdminUpdateTimeClockEntryInput!) {
    adminUpdateTimeClockEntry(input: $input) {
      ...TimeClockEntryFields
    }
  }
`;
